import { render } from "./FooterComponent.vue?vue&type=template&id=309c68fc"
const script = {}

import "./FooterComponent.vue?vue&type=style&index=0&id=309c68fc&lang=css"

import exportComponent from "/home/roland/coding/Kitchen101/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__